import React from "react";
import ModalAlertPro from "../../../components/ModalAlertPro/ModalAlertPro";
import ModalPrintTutupBuku from "../../../components/ModalPrintTutupBuku/ModalPrintTutupBuku";
import ModalUnduhLaporan from "../../../components/ModalUnduhLaporan/ModalUnduhLaporan";
import {
    ContentUkm,
    ParamsGetLaporanTotal,
    UserResponse,
} from "../../../constants/types";

interface LaporanModalsProps {
    closeModalAlertPro: () => void;
    closeModalPrintTutupBuku: () => void;
    closeModalUnduhLaporan: () => void;
    isOpenModalAlertPro: boolean;
    isOpenModalPrintTutupBuku: boolean;
    isOpenModalUnduhLaporan: boolean;
    nowK: string;
    paramsLaporanTotal: ParamsGetLaporanTotal;
    ukmData?: ContentUkm;
    user?: UserResponse["data"];
}

const LaporanModals = ({
    closeModalAlertPro,
    closeModalPrintTutupBuku,
    closeModalUnduhLaporan,
    isOpenModalAlertPro,
    isOpenModalPrintTutupBuku,
    isOpenModalUnduhLaporan,
    nowK,
    paramsLaporanTotal,
    ukmData,
    user,
}: LaporanModalsProps) => {
    return (
        <>
            {ukmData && isOpenModalAlertPro && (
                <ModalAlertPro
                    isOpenModalAlertPro={isOpenModalAlertPro}
                    closeModalAlertPro={closeModalAlertPro}
                    dataUkm={{ id: ukmData.id, nama: ukmData.namaToko }}
                />
            )}
            {isOpenModalUnduhLaporan && (
                <ModalUnduhLaporan
                    open={isOpenModalUnduhLaporan}
                    onClose={closeModalUnduhLaporan}
                    paramsUnduhLaporan={paramsLaporanTotal}
                    namaUkm={ukmData?.namaToko}
                />
            )}
            {isOpenModalPrintTutupBuku && (
                <ModalPrintTutupBuku
                    open={isOpenModalPrintTutupBuku}
                    onClose={closeModalPrintTutupBuku}
                    ukmData={ukmData}
                    user={user}
                    nowK={nowK}
                />
            )}
        </>
    );
};

export default LaporanModals;
